import { API_URL } from "@/constants/envVariables";

import { handleApiResponse } from "@/api/handleApiResponse";
import { handleSearchParams } from "@/api/handleSearchParams";

import { buildAuthHeaders, getAuthCredentials } from "@/helpers/authHeaders";

import { ApiDisbursementReceivers, PaginationParams } from "@/types";

export const getDisbursementReceivers = async (
  token: string,
  disbursementId: string,
  searchParams?: PaginationParams,
): Promise<ApiDisbursementReceivers> => {
  const params = handleSearchParams(searchParams);

  const response = await fetch(`${API_URL}/disbursements/${disbursementId}/receivers${params}`, {
    method: "GET",
    credentials: getAuthCredentials(),
    headers: {
      "Content-Type": "application/json",
      ...buildAuthHeaders(token),
    },
  });

  return handleApiResponse(response);
};
